import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=6a7206b9&scoped=true"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonIcon.vue?vue&type=style&index=0&id=6a7206b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7206b9",
  null
  
)

export default component.exports